import { type AsyncComponentLoader, defineAsyncComponent } from 'vue'

const logos: Record<string, AsyncComponentLoader> = {
  standard: defineAsyncComponent(() => import('./assets/logos/logo-main.svg')),
  wordmark: defineAsyncComponent(() => import('./assets/logos/logo-wordmark.svg')),
}

export default logos
